import { CLEAR_PARCEL } from "data/constants"

export function clearParcel() {
  return dispatch => dispatch({
    type: CLEAR_PARCEL,
  })
}



// WEBPACK FOOTER //
// ./src/data/actions/parcel.js